import { render, staticRenderFns } from "./solutionDetail.vue?vue&type=template&id=ea6b9530&scoped=true"
import script from "./solutionDetail.vue?vue&type=script&lang=js"
export * from "./solutionDetail.vue?vue&type=script&lang=js"
import style0 from "./solutionDetail.vue?vue&type=style&index=0&id=ea6b9530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6b9530",
  null
  
)

export default component.exports